module.exports = __webpack_public_path__ + "static/media/multipleprimarycancer.3cc7631e.svg";